export default function LabelInputWrapper({children, className}) {
	return <div className={`LabelInputWrapper ${className}`} >{children}</div>;
}
